import { render, staticRenderFns } from "./BeWelcomeScreen.vue?vue&type=template&id=98d189f8&scoped=true"
import script from "./BeWelcomeScreen.vue?vue&type=script&lang=js"
export * from "./BeWelcomeScreen.vue?vue&type=script&lang=js"
import style0 from "./BeWelcomeScreen.vue?vue&type=style&index=0&id=98d189f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d189f8",
  null
  
)

export default component.exports